<template>
    <div class="car-box" :class="[vehicle.status]" v-show="vehicle.isVisible">
        <div class="resources">
            <div class="screens" @click="requestSnapshot()">
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <div v-on="on">
                            <img src="../../../assets/icons/icon-screen-small.svg" alt="" /><br />
                            {{ vehicle.totalVideos || 0 }}
                        </div>
                    </template>
                    <span>Request snapshot</span>
                </v-tooltip>
            </div>
            <div class="videos" @click="requestVideo()">
                <v-tooltip right>
                    <template v-slot:activator="{ on }">
                        <div v-on="on">
                            <img src="../../../assets/icons/icon-video-small.svg" alt="" /><br />
                            {{ vehicle.totalVideos || 0 }}
                        </div>
                    </template>
                    <span>Request video</span>
                </v-tooltip>

            </div>
            <div class="calendar center" v-if="isActive">
                <img src="../../../assets/icons/icon-calendar-small.svg" alt="" />
            </div>
            <div class="map center" v-if="isActive" @click="centerCar()">
                <img src="../../../assets/icons/icon-pin-white.svg" alt="" />
            </div>
        </div>
        <div class="car-content">
            <div class="main-info" @click="expand()">
                <div class="license-plate">{{ vehicle.registrationNumber }}</div>
                <div class="speed" v-if="vehicle.status === statusOnline">{{ formatSpeed((vehicle.vehicleTracking == null)? 0: vehicle.vehicleTracking.sp) }}</div>
            </div>
            <div class="details" v-if="isActive">
                {{ address == null || address.label == null ? 'Unknown': address.label }}
            </div>
            <div class="table-buttons" v-if="isActive">
<!--                <router-link :to="{ name: 'journeyReport', query: { vehicleUuid:  vehicle.id } }">-->
<!--                    {{ $t('dashboard.fleetList.carBox.journeyReportLink') }}-->
<!--                </router-link>-->
                <div class="today-journey" @click="todaysJourney">
                    Open Journey Panel
<!--                    {{ $t('dashboard.fleetList.carBox.journeyTodaysLink') }}-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import toast from '@/plugins/izitoast'
import Vehicle from '@/models/Vehicle'
import { VEHICLE_ONLINE } from '@/config/tackingConfig'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { calculateSpeedOrDistanceUnit } from '@/helpers/Utils'
import { DeviceCommandApi, JourneyApi, DeviceEventApi, MediaRequestApi, MapLookupApi } from '@/api'
import SignalRDeviceCommandsWebhook from '@/api/SignalRDeviceCommandsWebhook'
import TrackingService from '@/services/TrackingService'
const { DeviceApi } = require('@/api')

const deviceCommandApi = new DeviceCommandApi()
const journeyApi = new JourneyApi()
const deviceEventApi = new DeviceEventApi()
const deviceApi = new DeviceApi()
const mediaRequestApi = new MediaRequestApi()
// const singalRDeviceCommands = new SignalRDeviceCommandsWebhook()

const mapLookupApi = new MapLookupApi()

export default {
    name: 'Car',
    data () {
        return {
            isActive: false,
            address: 'Unknown',
            statusOnline: VEHICLE_ONLINE,
            isVehicleSubscribed: false,
            geoCoding: null
        }
    },
    props: {
        vehicle: {
            required: true,
            type: Vehicle
        },
        active: {
            required: true
        }
    },
    watch: {
        isVehicleSubscribed (value) {
            if (value) {
                this.subscribeTrackingVehicle(this.vehicle)
            } else {
                this.unsubscribeTrackingVehicle(this.vehicle)
            }
        },
        'vehicle.vehicleTracking': {
            handler (value) {
                if (this.isActive) {
                    this.getAddressFromLatLng()
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters({
            getSpeedUnit: 'authModule/getSpeedUnit',
            getMenuState: 'layoutModule/getMenuState',
            getActiveJourneys: 'trackingModule/getActiveJourneys'
        })
    },
    methods: {
        ...mapActions({
            subscribeJourneyVehicle: 'trackingModule/subscribeJourneyVehicle',
            subscribeTrackingVehicle: 'trackingModule/subscribeTrackingVehicle',
            unsubscribeTrackingVehicle: 'trackingModule/unsubscribeTrackingVehicle',
            setCurrentVehicle: 'trackingModule/setCurrentVehicle',
            centerMapOnCar: 'trackingModule/centerMapOnCar',
            setMenuAction: 'layoutModule/setMenuAction',
            addActiveJourney: 'trackingModule/addActiveJourney',
            setLoading: 'trackingModule/setLoading',
            setIsJourneyTabActive: 'trackingModule/setIsJourneyTabActive',
            setIsOpenActionJourneyTab: 'trackingModule/setIsOpenActionJourneyTab',
            setLastActiveDate: 'trackingModule/setLastActiveDate'
        }),
        async expand () {
            this.isActive = !this.isActive
            this.isVehicleSubscribed = this.isActive

            if (this.isActive) {
                this.subscribeTrackingVehicle(this.vehicle)
                await this.getAddressFromLatLng()
            } else {
                this.unsubscribeTrackingVehicle(this.vehicle)
            }
        },
        async getAddressFromLatLng () {
            if (null == this.vehicle.vehicleTracking) {
                return
            }
            await mapLookupApi.address({ Latitude: this.vehicle.vehicleTracking.lat, Longitude: this.vehicle.vehicleTracking.lng }).then(response => {
                this.address = response.payload
            })
        },
        async requestVideo () {
            const response = await deviceCommandApi.requestVideo({
                hardwareId: this.vehicle.mediaHardwareId,
                channels: 0,
                videoLengthInSeconds: 10,
                date: moment().subtract(10, 'seconds')
            })

            const connection = this.$store.getters['signalRDeviceCommand/getConnection']
            const signalR = new SignalRDeviceCommandsWebhook(connection.connection)
            await signalR.sendTrackCommand(response.payload.deviceManualCommandId)

            toast.success('The request is being processed, you will receive a notification as soon as the video is available.')
        },
        async requestSnapshot () {
            const response = await deviceCommandApi.requestSnapshot({
                hardwareId: this.vehicle.mediaHardwareId,
                channels: 0,
                videoLengthInSeconds: 30,
                date: moment().subtract(30, 'seconds')
            })

            let connection = this.$store.getters['signalRDeviceCommand/getConnection']

            if (!connection) {

            }
            const signalR = new SignalRDeviceCommandsWebhook(connection.connection)
            await signalR.sendTrackCommand(response.payload.deviceManualCommandId)

            toast.success('The request is being processed, you will receive a notification as soon as the snapshot is available.')
        },
        centerCar () {
            this.centerMapOnCar(this.vehicle)
        },
        formatSpeed (speed) {
            return 0 === this.getSpeedUnit ? speed + ' KPH' : calculateSpeedOrDistanceUnit(speed, 'mi') + ' MPH'
        },
        async getJourneys () {
            // const dateFrom = moment(this.dateString).startOf('d').format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'
            // const dateTo = moment(this.dateString).endOf('d').format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'
            //
            await this.setLoading(true)

            const dateFrom = moment().startOf('d').format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'
            const dateTo = moment().endOf('d').format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'

            const [journeyResponse, eventsResponse, mediaResponse] = await Promise.allSettled([
                journeyApi.getJourneys(dateFrom, dateTo, this.vehicle.id, true),
                deviceEventApi.getDeviceEvents({
                    dateFrom,
                    dateTo,
                    vehicleId: this.vehicle.id,
                    recordLimit: 10000
                }),
                mediaRequestApi.getMediaRequests({
                    videoTimeFrom: dateFrom,
                    videoTimeTo: dateTo,
                    hardwareId: this.vehicle.mediaHardwareId
                })
            ])

            await this.setLastActiveDate(journeyResponse.value.payload.lastActiveDate)

            // TODO: error handling to discuss

            TrackingService.transformJourneyRequest(journeyResponse.value, eventsResponse.value, mediaResponse.value, this.vehicle)

            console.debug('Car::', this.vehicle)
            if (this.vehicle.mediaHardwareId) {
                const deviceResponse = await deviceApi.getDevice(this.vehicle.mediaHardwareId)

                if (deviceResponse.isSuccess) {
                    this.activeDevice = deviceResponse.payload
                }

                this.vehicle.deviceDetails = deviceResponse.payload
                this.vehicle.hardwareId = this.vehicle.mediaHardwareId
            }

            await this.setLoading(false)
        },
        async todaysJourney () {
            this.setLastActiveDate(null)
            this.setIsOpenActionJourneyTab(true)
            if (!this.$router.history.current.name.includes('dashboard')) {
                this.$router.push('/dashboard')
            }
            await this.setMenuAction(!this.getMenuState)
            await this.setIsJourneyTabActive(true)

            this.setCurrentVehicle(this.vehicle)

            if (!TrackingService.isJourneyVehicleSubscribe(this.vehicle)) {
                this.setIsOpenActionJourneyTab(true)
                await this.getJourneys()
                await this.subscribeJourneyVehicle(this.vehicle)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.car-box {
    display: flex;
    border-left: get($left-border, width) solid transparent;
    position: relative;

    &:hover {
        .car-content {
            background: $dark;
        }
    }

    &.online {
        border-left-color: $success;

        .license-plate {
            &::after {
                background: url('../../../assets/icons/icon-pin-green.svg');
            }
        }

        &::after {
            content: '';
            display: inline-block;
            background: url('../../../assets/icons/icon-arrow-left.svg');
            width: 10px;
            height: 10px;
            position: absolute;
            right: 10px;
            top: 24px;
        }
    }

    &.offline {
        border-left-color: $danger;

        .license-plate {
            &::after {
                background: url('../../../assets/icons/icon-pin-red.svg');
            }
        }
    }

    &.inactive {
        border-left-color: $inactive;

        .license-plate {
            color: $inactive;

            &::after {
                background: url('../../../assets/icons/icon-pin-grey.svg');
            }
        }
    }

    &.active {
        background: $white;
        color: $dark;

        .car-content {
            padding: 9px 0 0 0;
            flex-direction: column;
            align-items: normal;
            background: $white;
            color: $dark;
        }
    }

    .resources {
        width: 30px;
        font-size: 9px;
        text-align: center;
        color: $white;

        .screens,
        .videos,
        .calendar,
        .map {
            width: 30px;
            height: 30px;
            padding: 2px 0;

            &.center {
                display: flex;
                align-items: center;

                img {
                    margin: auto;
                }
            }
        }

        .screens,
        .calendar {
            background: $dark;
        }

        .videos,
        .map {
            background: $secondary-default;
        }

        .screens,
        .videos,
        .map {
            cursor: pointer;

            &:hover {
                background: $primary-default;
            }
        }
    }

    .car-content {
        display: flex;
        width: 100%;
        align-items: center;
        cursor: pointer;
        font-size: 14px;
        flex-wrap: wrap;

        .main-info {
            display: flex;
            width: 100%;
            height: 40px;
            padding-top: 18px;
            padding-left: 16px;
            padding-right: 40px;
            margin-bottom: auto;

            .license-plate {
                display: flex;
                align-items: center;

                &::after {
                    content: '';
                    display: inline-block;
                    width: 10px;
                    height: 15px;
                    margin-left: 10px;
                }
            }

            .speed {
                display: flex;
                align-items: center;
                margin-left: auto;
                font-size: 12px;
                color: $success;

                &:before {
                    content: '';
                    width: 9px;
                    height: 12px;
                    background: url('../../../assets/icons/icon-speed.svg');
                    margin-right: 7px;
                }
            }
        }

        .details {
            padding: 3px 16px;
            font-size: 12px;
            height: 46px;
            background: $white;
            color: $dark;
            width: 100%;
            margin-top: 7px;
        }

        .table-buttons {
            display: flex;
            margin-top: auto;
            background: $white;
            width: 100%;

            a, div {
                display: inline-block;
                width: 100%;
                color: $dark;
                text-align: center;
                border: 3px solid $dark;
                border-right-width: 0;

                &:first-child {
                    border-left-width: 0;
                }
            }
        }
    }
}
</style>
